import React from 'react';

import Tooltip from 'components/tooltip';

import IconHelp from 'icons/icon-help';

const AppHelpButton = () => {
    return (
        <Tooltip tooltip="Help">
            <a className="app-help-button" href="https://help.niftypm.com" target="_blank" rel="noopener noreferrer">
                <IconHelp />
            </a>
        </Tooltip>
    )
}


export default AppHelpButton;
